import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { UPLOAD, SET, DELETE, CLEAR } from '@hobs/constants/attachment';

export function uploadAttachments(body) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('attachments', {
      body: body,
      method: 'POST',
      multipart: true
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        } else {
          dispatch(failure(response.payload.message));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPLOAD.REQUEST };
  }
  function success(response) {
    return { type: UPLOAD.SUCCESS, response };
  }
  function failure(error) {
    return { type: UPLOAD.FAILURE, error };
  }
}

export function setAttachments(attachments) {
  return dispatch => {
    dispatch({ type: SET.SUCCESS, attachments });
  };
}

export function deleteAttachment(file) {
  return dispatch => {
    dispatch({ type: DELETE.SUCCESS, file });
  };
}

export function clearAttachments() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}
